/** Resets every Redux slice to its initial state (logout / session error). */
export const RESET_APP_STATE = "RESET_APP_STATE";

export const resetAppState = () => ({ type: RESET_APP_STATE });
